const AIRPORT_NAMES_JA = {
  T1: "成田空港第1ターミナル",
  T2: "成田空港第2ターミナル",
  T3: "成田空港第3ターミナル",
  "HND-T1": "羽田空港第1ターミナル",
  "HND-T2": "羽田空港第2ターミナル",
  "HND-T3": "羽田空港第3ターミナル(国際線)",
};

const AREA_NAMES_JA = {
  narita_airport: "成田空港",
  haneda_airport: "羽田空港",
  tokyo: "東京",
  hakone: "箱根",
  yokohama: "横浜",
  kawasaki: "川崎",
  chiba: "千葉",
  saitama: "埼玉",
  karuizawa: "軽井沢",
  odawara: "小田原",
  kamakura: "鎌倉",
  nikko: "日光",
  kawagoe: "川越",
  fuji: "富士山",
  mt_fuji: "富士山",
  atami: "熱海",
  izu: "伊豆",
  gotemba: "御殿場",
};

const TERMINAL_NAMES_JA = {
  T1: "第1ターミナル",
  T2: "第2ターミナル",
  T3: "第3ターミナル",
  "HND-T1": "第1ターミナル",
  "HND-T2": "第2ターミナル",
  "HND-T3": "第3ターミナル(国際線)",
  hotel: "ホテル送迎",
};

const VEHICLE_TYPE_JA = {
  alphard: "アルファード",
  hiace: "ハイエース",
  premium_hiace: "プレミアムハイエース",
  coaster: "コースター",
  bus: "バス",
  hiace_14_seats: "14座ハイエース",
};

const getOrderNo = (order) =>
  order.order_no ||
  order.customer_code ||
  (order.id !== undefined && order.id !== null
    ? `${String(order.id).slice(0, 8)}...`
    : "未設定");

const STATUS_JA = {
  pending: "保留中",
  confirmed: "確定",
  completed: "完了",
  cancelled: "キャンセル",
  pending_quote: "見積もり中",
};

const EXTRA_SERVICES_JA = {
  airport_sign: "空港でのお出迎えボード",
  airport_pickup_sign: "空港でのお出迎えボード",
  tokyo_station_sign: "東京駅お出迎えボード",
  odawara_station_sign: "小田原駅お出迎えボード",
  shinkansen_ticket: "新幹線チケット受取",
  hiace_14_seat_upgrade: "14座ハイエースアップグレード",
  fuji_5th_station: "富士山五合目追加費",
  child_seat: "チャイルドシート",
  infant_seat: "ベビーシート",
  wheelchair: "車椅子対応",
  pet_friendly: "ペット同伴可",
  extra_luggage: "追加荷物",
  meet_greet: "ミート&グリート",
  extended_waiting_time: "待機時間延長",
};

const copyText = (text, successMessage) => {
  navigator.clipboard.writeText(text).then(() => {
    alert(successMessage);
  }).catch(() => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    alert(successMessage);
  });
};

const getAirportFullName = (code) => {
  if (!code) return "";
  for (const [key, name] of Object.entries(AIRPORT_NAMES_JA)) {
    if (code.includes(key) || code.toUpperCase().includes(key)) {
      return name;
    }
  }
  return code;
};

const uniqueJoin = (parts) => {
  const uniqueParts = [...new Set(parts.filter(Boolean))];
  return uniqueParts.length > 0 ? uniqueParts.join(" ") : "未入力";
};

const getPickupFullAddress = (order) => {
  const parts = [];
  if (AREA_NAMES_JA[order.pickup_area]) {
    parts.push(AREA_NAMES_JA[order.pickup_area]);
  }
  if (order.pickup_terminal) {
    parts.push(TERMINAL_NAMES_JA[order.pickup_terminal] || order.pickup_terminal);
  }
  if (order.pickup_location_detail) {
    parts.push(order.pickup_location_detail);
  } else if (order.pickup_location) {
    parts.push(getAirportFullName(order.pickup_location));
  }
  if (order.pickup_address) {
    parts.push(order.pickup_address);
  }
  return uniqueJoin(parts);
};

const getDestinationFullAddress = (order) => {
  const parts = [];
  if (AREA_NAMES_JA[order.dropoff_area]) {
    parts.push(AREA_NAMES_JA[order.dropoff_area]);
  }
  if (order.dropoff_terminal) {
    parts.push(TERMINAL_NAMES_JA[order.dropoff_terminal] || order.dropoff_terminal);
  }
  if (order.dropoff_location_detail) {
    parts.push(order.dropoff_location_detail);
  } else if (order.destination) {
    parts.push(order.destination);
  } else if (order.destination_address) {
    parts.push(order.destination_address);
  } else if (order.dropoff_location) {
    parts.push(order.dropoff_location);
  }
  return uniqueJoin(parts);
};

const getSelectedServices = (order) => {
  const services = [];
  if (order.airport_pickup_sign) services.push("空港でのお出迎えボード");
  if (order.child_seat) services.push("チャイルドシート");
  if (order.wheelchair) services.push("車椅子対応");
  if (order.pet_friendly) services.push("ペット同伴可");

  if (Array.isArray(order.extra_services)) {
    order.extra_services.forEach((service) => {
      const quantity = Math.max(1, Number(service.quantity) || 1);
      const pickupArea = String(order.pickup_area || "").toLowerCase();
      const baseMinutes = pickupArea.includes("airport") || pickupArea.includes("port") ? 90 : 30;
      const serviceName = service.service_type === "extended_waiting_time"
        ? `待機時間延長 +${quantity * 30}分 / 合計${baseMinutes + quantity * 30}分`
        : (EXTRA_SERVICES_JA[service.service_type] || service.service_type);
      if (!services.includes(serviceName)) {
        services.push(serviceName);
      }
    });
  }
  return services;
};

export const exportOrderInfoJapanese = (order) => {
  const services = getSelectedServices(order);
  const serviceTypeJa = order.service_type === "charter" ? "チャーター" : "片道送迎";

const text = `【注文情報】
注文番号: ${getOrderNo(order)}

【お客様情報】
お客様コード: ${order.customer_code || "未設定"}
お客様名: ${order.customer_name || "未入力"}
電話番号: ${order.customer_phone || order.phone || "未入力"}

【行程情報】
サービスタイプ: ${serviceTypeJa}${order.service_type === "charter" && order.selected_hours ? `
チャーター時間: ${order.selected_hours}時間` : ""}
出発日: ${order.departure_date || "未入力"}
出発時間: ${order.pickup_time || "未入力"}
乗車場所: ${getPickupFullAddress(order)}
目的地: ${getDestinationFullAddress(order)}
車種: ${VEHICLE_TYPE_JA[order.vehicle_type] || VEHICLE_TYPE_JA[order.vehicle_type_v2] || order.vehicle_type || "未入力"}
乗客人数: ${order.passenger_count || 0}名
荷物数: ${order.luggage_count || 0}個
フライト番号: ${order.flight_number || "未入力"}${services.length > 0 ? `

【追加サービス】
${services.map((service) => `- ${service}`).join("\n")}` : ""}

【注文状態】
状態: ${STATUS_JA[order.status] || order.status || "未設定"}${order.assigned_driver ? `

【配車情報】
車両: ${order.assigned_driver.vehicle_brand || "TOYOTA"} ${VEHICLE_TYPE_JA[order.assigned_driver.vehicle_type] || order.assigned_driver.vehicle_type || ""}
ナンバー: ${order.assigned_driver.plate_number || "未設定"}
ドライバー: ${order.assigned_driver.driver_name || "未設定"}
電話番号: ${order.assigned_driver.driver_phone || "未設定"}` : ""}

【備考】
${order.trip_details || "無し"}`;

  copyText(text, "订单信息已复制到剪贴板（日语版）");
};
